import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { useCallOptions } from '../../hooks/useCallOptions.js';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import styles from '../base/CommonSettings.module.scss';
import Select, { oldArrToSelectFormatter} from '../../../common/Select.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

// Missing text_legend_color settings
function CallProgressWidgetSettings({widgetId}) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const {data: callOptions} = useCallOptions();
    const call_id = useSelector(state => state.dashboard.widgets[widgetId].settings?.call_id);
    const submit_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.submit_color);
    const draft_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.draft_color);
    const drop_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.drop_color);
    const callOptionsSelect = useMemo(() => oldArrToSelectFormatter(callOptions, 'id', 'name'), [callOptions]);

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <div className={styles['settings-section']}>
                <WidgetTitleSettings widgetId={widgetId} />
                <div className={styles['settings-option']}>
                    <label>{I18n.t("call")}</label>
                    <Select
                        value={call_id}
                        options={callOptionsSelect}
                        onChange={(val) => setAttribute('settings.call_id', val)}
                    />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t("submitted_or_approved_color")}</label>
                    <ColorPicker value={submit_color} onChange={(value) => setAttribute('settings.submit_color', value)} />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t("draft_or_unprocessed_color")}</label>
                    <ColorPicker value={draft_color} onChange={(value) => setAttribute('settings.draft_color', value)} />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t("dropped_color")}</label>
                    <ColorPicker value={drop_color} onChange={(value) => setAttribute('settings.drop_color', value)} />
                </div>
            </div>
        </CollapsibleSection>
    </>)
}

export default CallProgressWidgetSettings;
